<template>

    <v-dialog v-model="show" persistent max-width="1200" @keydown="(k) => {k.key == 'Escape' ? show = false : null}">
      <v-card>
        <v-card-title>{{$props.title}} Documentation</v-card-title>

        <v-card-text>

            <iframe class="report-doc-iframe" :srcdoc="$props.docs" />
            
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text @click.stop="show=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
export default {
  name: 'DocsDialog',
  props: ['value', 'title', 'docs'],
  data: () => ({
      formattedDocs: ''
  }),

  computed: {
    show: {
        get () {
            return this.value
        },
        set (value) {
            this.$emit('input', value)
        }
    }
    
  },

  methods: {

  },

  mounted() {
  }

  
};
</script>

<style scoped>

    .report-doc-iframe {
        width: 100%;
        height: calc(100vh - 350px);
        background-color: #ffffff;
    }

</style>

